export const splitDate = (date) => {
  return date.split("T")[0];
};

export const dateFormat = (date) => {
  let newDate = splitDate(date);
  newDate = newDate.split("-");
  return `${newDate[2]}.${newDate[1]}.${newDate[0]}`;
};
